import type { ReactElement } from "react";
import { CmtsNotificationsContainer } from "../../core/containers/domain/workspaceRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsNotificationsContainer runtime={props.runtime} />;
}

export default Component;
